export const ConfigType = {
  // SUBMITTED_OFFER_ALLOWED_DOCUMENTS = "SUBMITTED_OFFER_ALLOWED_DOCUMENTS",
  SIGNATURE_LABEL: 'SIGNATURE_LABEL',
  SUBMITTED_OFFER_CHECKING: 'SUBMITTED_OFFER_CHECKING',
  TESTING_EMAIL: 'TESTING_EMAIL',
  TESTING_SIGN_COMMERCIAL_USER_NAME: 'TESTING_SIGN_COMMERCIAL_USER_NAME',
  TESTING_SIGN_TECHNICAL_USER_NAME: 'TESTING_SIGN_TECHNICAL_USER_NAME',
  OFFER_MAINTENANCE_TERM_AND_CONDTION_FILE: 'OFFER_MAINTENANCE_TERM_AND_CONDTION_FILE',
  OFFER_PROJECT_TERM_AND_CONDTION_FILE: 'OFFER_PROJECT_TERM_AND_CONDTION_FILE',
  OFFER_MAINTENANCE_VIEW_TEAM: 'OFFER_MAINTENANCE_VIEW_TEAM',
  OFFER_PROJECT_VIEW_TEAM: 'OFFER_PROJECT_VIEW_TEAM',
  OFFER_BOOKING_COMMERCIAL_TO_1: 'OFFER_BOOKING_COMMERCIAL_TO_1',
  OFFER_BOOKING_COMMERCIAL_TO_2: 'OFFER_BOOKING_COMMERCIAL_TO_2',
  OFFER_COST_SHEET_TEMPLATE: 'OFFER_COST_SHEET_TEMPLATE',
  OFFER_CONDITION_OF_PURCHASE_FILE: 'OFFER_CONDITION_OF_PURCHASE_FILE',
  OFFER_SOURCING_THRESHOLD: 'OFFER_SOURCING_THRESHOLD',
  OFFER_PR_LEVEL_3_TECHNICAL_REQUIRED_THRESHOLD: 'OFFER_PR_LEVEL_3_TECHNICAL_REQUIRED_THRESHOLD',
  OFFER_PR_SUBCONTRACTOR_AGREEMENT_REQUIRED_THRESHOLD: 'OFFER_PR_SUBCONTRACTOR_AGREEMENT_REQUIRED_THRESHOLD',
  OFFER_LOGISTIC_USER: 'OFFER_LOGISTIC_USER',
  OFFER_GCPR_LOGISTIC_USER: 'OFFER_GCPR_LOGISTIC_USER',
  OFFER_HSP1_USER: 'OFFER_HSP1_USER',

  EMAIL_LOGIN_ALLOWED: 'EMAIL_LOGIN_ALLOWED',

  INTERNAL_USER_MANUAL: 'INTERNAL_USER_MANUAL',
  EXTERNAL_USER_MANUAL: 'EXTERNAL_USER_MANUAL',
}

export const ConfigCategory = {
  TESTING: 'testing',
  OFFER: 'offer',
}
